import type { IconData } from '@stacksjs/iconify-core'

export const toast: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M43 13.32c1.246 1.124 2 2.705 2 4.68c0 2.879-1.603 4.924-4 5.929c0 6.3-.164 11.798-.312 15.464c-.112 2.787-2.178 5.055-4.958 5.276c-2.237.177-5.21.33-8.79.33c-3.498 0-6.417-.146-8.636-.319c-2.046-.158-3.702-1.422-4.498-3.18\"/><path d=\"M9.937 3.393C6.006 3.68 3 6.058 3 10c0 2.897 1.623 4.949 4.044 5.947c.059 6.203.165 11.628.25 15.29c.067 2.856 2.16 5.223 5.01 5.444c2.22.172 5.138.319 8.637.319c3.579 0 6.552-.154 8.79-.331c2.78-.22 4.845-2.49 4.957-5.276c.148-3.665.312-9.164.312-15.464c2.397-1.005 4-3.05 4-5.929c0-3.942-3.005-6.32-6.937-6.607C29.184 3.183 25.407 3 21 3s-8.184.184-11.063.393M20 12v1m8 8v1m-12 4v1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toast
